const messages = {
  title: "Country selection",
  dismissAria: "Dismiss country notice",
  flagAlt: "{code} flag",
  currentTenant:
    "You are currently on Bridgestone Plus {name} ({code}).",
  visitingFrom: "It looks like you are visiting from {name}.",
  suggestPlatform:
    "Would you like to continue on the {name} platform instead?",
  lookingFor:
    "Looking for {name} ({code})? You can switch in one click.",
  switchTo: "Switch to {code}",
};

export default {
  messages,
};
